import { func, number, shape, string } from 'prop-types';

export const IntegratedBrandPropTypes = {
  collection: shape({
    details: shape({}),
    metadata: shape({
      brandName: string,
      name: string,
      pageSize: number,
      productCount: shape({
        allProducts: string,
        inStore: string
      }),
      roomType: string,
      startIndex: number,
      type: string
    })
  }).isRequired,
  collectionId: string.isRequired,
  storeId: string.isRequired,
  skipFn: func.isRequired
};
